class printMasterCashScheduleController {
    /*@ngInject*/
    constructor($scope) {
        this.$scope = $scope;
        this.model = {
            printData: null
        };
    }

    $onInit() {
        if (window.opener && window.opener.w && window.opener.w.printData) {
            this.model.printData = window.opener.w.printData;
            this.print();
        }
    };

    print() {
        setTimeout(() => {
            window.print();
        }, 1500);
    };
}

export default printMasterCashScheduleController;



// WEBPACK FOOTER //
// ./client/app/components/master_cash_schedule/print/print_master_cash_schedule.controller.js